// extracted by mini-css-extract-plugin
export default {"wrapper":"Upload_wrapper__39cSE"};